import * as React from 'react';
import * as Scroll from 'react-scroll';

export interface SectionProps {
    id: string;
    title: string;
    children: React.ReactNode;
}

export function Section(props: SectionProps) {
    return (
        <div className="section" id={props.id}>
            <div className="section-content">
                <h1>{props.title}</h1>
                {props.children}
            </div>
        </div>
    );
}

export default Section;